import { DASHBOARD_BASE_URL } from '../services/urls';

export const ECOMMERCE_NA_PRATICA_URL = `${DASHBOARD_BASE_URL}/e-commerce-na-pratica`;
export const D2C_EVENT_URL = `${DASHBOARD_BASE_URL}/d2c-event`;

export const DashboardEndpoints = {
  getEcommerceNaPratica: 'getEcommerceNaPratica',
  getD2cEvent: 'getD2cEvent',
} as const;
